import styled from "styled-components";

export const DrawerAuthSection = styled.div`
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
`;
